import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Circular brand mark. Filled olive-accent circle with a single
// heading-cased letter inside. Used as a placeholder until we have
// a real wordmark/emblem — the prototype uses the same treatment.
export const mark = style({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  borderRadius: vars.radius.full,
  backgroundColor: vars.color.sidebarAccent,
  color: vars.color.sidebarAccentText,

  fontFamily: vars.font.heading,
  fontWeight: vars.fontWeight.bold,
  letterSpacing: "0.02em",

  userSelect: "none",
  flexShrink: 0,
});
